// import Vue from 'vue'
import Vuex from 'vuex'

import animation from './modules/animation'
import common from './modules/common'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    animation,
    common
  }
})

export default store
